import Spritesheet from "./Spritesheet";

/**
 * @abstract
 */
export default class NamedSpriteSpritesheet extends Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     */
    constructor(fileName, spriteSize) {
        super(fileName, spriteSize);

        /**
         * The mapping of sprites by name.
         * @private
         * @type {{}}
         */
        this.spriteMap = {};
    }

    /**
     * @param {string} name
     * @returns {Sprite}
     */
    getSprite(name) {
        return this.spriteMap[name];
    }
}